import { getAppSettings } from '../../config/appSettings';

export const useDecisionShowSearchV2 = (): boolean => {
  const appSettings = getAppSettings();
  const isDecisionShowSearchV2 = appSettings.features.isCompanySearchV2On;
  return isDecisionShowSearchV2;
};
